import axios from 'axios';
import http from './httpService';
const apiUrl = process.env.REACT_APP_API_URL;

const apiEndpoint = apiUrl + '/supervisors';

function userUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getSupervisors() {
  return http.get(apiEndpoint)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}

export function getSupervisor(supervisorId) {
  return http.get(`${apiEndpoint}/${supervisorId}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}



export function saveSupervisor(user, imageSrc) {
  if (!process.env.REACT_APP_API_URL) {
    return Promise.reject(new Error("API URL not configured"));
  }

  const formData = new FormData();

  if (user._id) {
    // UPDATE - use PUT /supervisors/:id with FormData
    const body = { ...user };
    const userId = body._id; // Store the ID before deleting it
    delete body._id;
    
    // Transform data to flat structure for form submission
    if (body.longitude) body.longitude = parseFloat(body.longitude) || 0;
    if (body.latitude) body.latitude = parseFloat(body.latitude) || 0;
    
    // Convert date to string if it's a Date object
    if (body.dateBirth && typeof body.dateBirth !== 'string') {
      body.dateBirth = body.dateBirth.toISOString();
    }
    
    // Append all fields to FormData
    for (let key in body) {
      formData.append(key, body[key]);
    }
    
    // Append imageSrc
    formData.append('imageSrc', imageSrc);
    
    return http.put(`${apiEndpoint}/${userId}`, formData, {
      headers: {
        'Content-Type': undefined // Let browser set multipart/form-data with boundary
      }
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error('PUT error:', error);
        throw error;
      });
  }
  
  // CREATE - use POST /supervisors with FormData
  const body = { ...user };
  
  if (body.longitude) body.longitude = parseFloat(body.longitude) || 0;
  if (body.latitude) body.latitude = parseFloat(body.latitude) || 0;
  
  // Convert date to string if it's a Date object
  if (body.dateBirth && typeof body.dateBirth !== 'string') {
    body.dateBirth = body.dateBirth.toISOString();
  }
  
  // Append all fields to FormData
  for (let key in body) {
    formData.append(key, body[key]);
  }
  
  // Append imageSrc
  formData.append('imageSrc', imageSrc);
  
  return http.post(apiEndpoint, formData, {
    headers: {
      'Content-Type': undefined // Let browser set multipart/form-data with boundary
    }
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
}

export function patchSupervisor(user, imageSrc) {
  const formData = new FormData();
  if (user._id) {
    const body = { ...user };
    delete body._id;
    delete body.imageSrc;
    for (let key in body) {
      formData.append(key, body[key]);
    }
    formData.append('imageSrc', imageSrc);
    
    return http.patch(`${apiEndpoint}/${user._id}`, formData);
  }
}

export function deleteSupervisor(supervisorId) {
  return http.delete(`${apiEndpoint}/${supervisorId}`);
}  